import React, { useState } from 'react';
import _ from 'lodash';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { useOutletContext } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import convertYangMing from './RatesConvert.yangming.js';
import ConvertMsc from './RatesConvert.msc.js';
import ConvertZim from './RatesConvert.zim.js';

export default function RatesConvert() {
    const { org, seaPorts, DrawerIcon = null } = useOutletContext();
    const [ supplier, setSupplier ] = useState('');
    const [ supplierEmail, setSupplierEmail ] = useState('');
    const [ form, setForm ] = useState('');
    const [ step, setStep ] = useState(1);
    const [ csvData, setCsvData ] = useState([]);
    const [ converter, setConverter ] = useState('zim-to-monada');
    const [ _seaPorts, setSeaPorts ] = useState('');
    const [ textFromFileLoaded, setTextFromFileLoaded ] = useState(null);
    const [ autoskip, setAutoskip ] = useState(false);

    if (!seaPorts) {
        return (
            <div style={{ padding: '24px' }}>
                Please wait....
            </div>
        )
    }

    function onLoadFile() {
        try {
            const fileToLoad = document.getElementById('fileToLoad').files[0];

            const fileReader = new FileReader();
            fileReader.onload = async function(fileLoadedEvent){
                setTextFromFileLoaded(fileLoadedEvent.target.result);
                /*
                let parsed = [];
                if (converter === 'zim-to-monada') {
                    parsed = await convertZim({ data: textFromFileLoaded, formObj: org.forms[form], supplier, supplierEmail, seaPorts });
                } else if (converter === 'msc-to-monada') {
                    parsed = await convertMsc({ data: textFromFileLoaded, formObj: org.forms[form], supplier, supplierEmail, seaPorts });
                } else if (converter === 'yangming-to-monada') {
                    parsed = await convertYangMing({ data: textFromFileLoaded, formObj: org.forms[form], supplier, supplierEmail, seaPorts });
                }
                */
            };

            fileReader.readAsText(fileToLoad, 'UTF-8');
        } catch(e) {
            console.error(e);
        }
    }

    function onDoneConvert(parsed) {
        setCsvData(toCSV(parsed));
        setStep(3);
    }

    function convertPorts() {
        const destinations = _seaPorts.split('\n');
        let ret = '';
        destinations.forEach(d => {
            const source = seaPorts.find(p => matchSeaPort({ name: d, option: p }));
            if (!source) {
                ret += '---\n';
            } else {
                ret += source.code + '\n';
            }
        });
        setSeaPorts(ret);
    }

    return (
        <Box>
            <Box sx={{ flexGrow: 1, display: { xs: 'block', md: 'none' }, paddingBottom: '60px' }}>
                <AppBar position='fixed'>
                    <Toolbar>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: '48px', width: '100%' }}>
                            {DrawerIcon}
                            <Typography variant='h1' style={{ color: 'white', fontSize: '24px', fontFamily: '\'DM Serif Display\', serif', fontWeight: '400', paddingLeft: '12px' }}>
                                Monada
                            </Typography>
                            <Typography variant='h5' sx={{ flex: 1 }}>
                                &nbsp;&nbsp;Rates - Convert
                            </Typography>
                        </div>
                    </Toolbar>
                </AppBar>
            </Box>
            <Box sx={{ p: 3 }}>
                <Box sx={{ alignItems: 'center', marginBottom: '24px', flex: 1, display: { xs: 'none', md: 'flex' }}}>
                    <Typography variant='h6' sx={{ flex: 1 }}>
                        RATES - Convert
                    </Typography>
                </Box>
            </Box>
            {step === 1 && (
                <Step1 
                    supplier={supplier}
                    setSupplier={setSupplier}
                    converter={converter}
                    setConverter={setConverter}
                    supplierEmail={supplierEmail}
                    setSupplierEmail={setSupplierEmail}
                    form={form}
                    setForm={setForm} 
                    org={org}
                    onNext={() => setStep(2)}
                />
            )}
            {step > 1 && (
                <Box sx={{ p: 3, pt: 0 }}>
                    <Box>
                        <b>Supplier:</b>&nbsp;{supplier}
                    </Box>
                    <Box>
                        <b>Supplier Email:</b>&nbsp;{supplierEmail}
                    </Box>
                    <Box>
                        <b>Form:</b>&nbsp;{org.forms[form].title}
                    </Box>
                    <Box>
                        <b>Converter:</b>&nbsp;{converter}
                    </Box>
                </Box>
            )}
            {step === 2 && !textFromFileLoaded && (
                <Box sx={{ p: 3, pt: 0 }}>
                    <Box>
                        Select a File to Load:
                    </Box>
                    <Box sx={{ pt: 3, pb: 3 }}>
                        <input type='file' id='fileToLoad' />
                    </Box>
                    <Button fullWidth variant='contained' disabled={!supplier || !supplierEmail || !form} onClick={onLoadFile}>
                        Load File
                    </Button>
                    <Checkbox checked={autoskip} onChange={e => setAutoskip(!autoskip)} /> Automatically approve all conversion.
                </Box>
            )}
            {step === 2 && textFromFileLoaded && converter === 'msc-to-monada' && (
                <ConvertMsc
                    data={textFromFileLoaded}
                    formObj={org.forms[form]}
                    supplier={supplier}
                    supplierEmail={supplierEmail}
                    seaPorts={seaPorts}
                    onDone={onDoneConvert}
                    autoskip={autoskip}
                />
            )}
            {step === 2 && textFromFileLoaded && converter === 'zim-to-monada' && (
                <ConvertZim
                    data={textFromFileLoaded}
                    formObj={org.forms[form]}
                    supplier={supplier}
                    supplierEmail={supplierEmail}
                    seaPorts={seaPorts}
                    onDone={onDoneConvert}
                    autoskip={autoskip}
                />
            )}
            {step === 3 && (
                <Box sx={{ p: 3, pt: 0 }}>
                    <CSVLink data={csvData} filename={`${new Date().getYear() + 1900}-${new Date().getMonth() + 1}-${new Date().getDate()}-${supplier}.csv`}>Download CSV Result</CSVLink>
                    <Button fullWidth variant='contained' onClick={() => {setTextFromFileLoaded(null); setStep(2)}} sx={{ marginTop: '24px' }}>
                        Back
                    </Button>
                </Box>
            )}
            <Box sx={{ p: 3, pt: 0 }}>
                <hr />
            </Box>
            <Box sx={{ p: 3, pt: 0 }}>
                <TextField
                    label='Convert Sea Ports'
                    placeholder='Convert Sea Ports'
                    multiline
                    value={_seaPorts}
                    onChange={e => setSeaPorts(e.target.value)}
                />
                <Button onClick={convertPorts} sx={{ mt: 3 }} >Convert</Button>
            </Box>
        </Box>
    )
}

function Step1(props) {
    const { supplier, setSupplier, supplierEmail, setSupplierEmail, form, setForm, org, onNext, converter, setConverter } = props;
    return (
        <Box>
            <Grid container spacing={3} sx={{ p: 3, pt: 0 }}>
                <Grid item xs={12} md={4}>
                    <TextField
                        id='supplier'
                        label='Supplier (organization)'
                        value={supplier}
                        onChange={e => setSupplier(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={8}>
                    <TextField
                        id='supplieremail'
                        label='Supplier (email)'
                        value={supplierEmail}
                        onChange={e => setSupplierEmail(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id='form-label'>Form</InputLabel>
                        <Select
                            labelId='form-label'
                            label='Form'
                            id='form'
                            value={form}
                            onChange={(event: SelectChangeEvent) => { setForm(event.target.value) }}
                        >
                            {_(org.forms).pickBy((f, k) => f.type !== 'price-quote' && !f.deleted).map((v, form) => (<MenuItem key={form} value={form}>{v.title}</MenuItem>)).value()}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id='converter-label'>Converter</InputLabel>
                        <Select
                            labelId='converter-label'
                            label='Converter'
                            id='converter'
                            value={converter}
                            onChange={(event: SelectChangeEvent) => { setConverter(event.target.value) }}
                        >
                            <MenuItem value={'zim-to-monada'}>ZIM to Monada</MenuItem>
                            <MenuItem value={'msc-to-monada'}>MSC to Monada</MenuItem>
                            <MenuItem value={'yangming-to-monada'}>YangMing to Monada</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <div style={{ padding: '12px', paddingTop: '16px' }}>
                <Button fullWidth variant='contained' disabled={!supplier || !supplierEmail || !form} onClick={onNext}>
                    Next
                </Button>
            </div>
        </Box>
    );
}

function toCSV(rates) {
    let keys = ['source', 'destination', 'transportationMethod', 'product', 'validFrom', 'validUntil', 'transitTime', 'form', 'supplier', 'supplierEmail'];
    rates.forEach(r => keys = _.uniq([...keys, ..._.keys(r)]));
    let result = [keys];
    rates.forEach(r => result.push(keys.map(k => r[k])));
    return result;

}

function matchSeaPort({ name, option }) {
    const n = _.trim(name);
    if (option.code === n) return true;
    if (n.toUpperCase().indexOf(option.portname.toUpperCase()) > -1) return true;
    if ((option.aka || []).includes(n.toUpperCase())) return true;
    return false;
}
